import React from 'react';
import {Link, useNavigate} from "react-router-dom";
import {convertToJalaliWithFormat} from "@/lib/utils/date";
import {Can} from "@/components/can/Can";
import PermList from "@/lib/helper/PermList";

import {Button, Progress, Tag} from "antd";

import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import TableSearch from "@/components/table/tableSearch";
import {useApiSearchAdminProductsDeliveryStep} from "@/api/product";
import {toFaNumberFormat} from "@/lib/utils/number";
import {sprintf} from "@/lib/utils/sprintf";
import RenderIf from "@/components/render-if";

function AdminProductDeliveryStepList(props) {
    const navigate = useNavigate();


    const columns = [
        {
            title: '#',
            dataIndex: 'id',
            key: 'id',
            width: 120,
            responsive: ['md'],
            render: (text, record) => (
                <>
                    {toFaNumberFormat(text) + ' # '}
                    <Can permission={PermList.PRODUCT_DELIVERY_EDIT}>
                        <Link to={sprintf(URLS.admin.products.delivery.edit, {id: record.id})}>
                            <Button size="small" type="dashed">
                                جزئیات
                            </Button>
                        </Link>
                    </Can>
                </>
            ),
        },

        {
            title: 'توضیحات',
            dataIndex: 'description',
            key: 'description',
            responsive: ['md'],
            render: (text, record) => (<>
                <div className="flex gap-2 flex-col">
                    {text}
                    <RenderIf condition={record.category}>
                        <span>
                            <Link to={sprintf(URLS.admin.products.delivery.category, {category: record.category})}>
                                <Tag color="blue"> کد: {record.category}</Tag>
                            </Link>
                        </span>
                    </RenderIf>

                    <RenderIf condition={record.meta?.deliver_to_lesson}>
                        <span>
                            <Tag color="purple">تحویل به مربی</Tag>
                        </span>
                    </RenderIf>

                </div>
            </>)
        },

        {
            title: 'تعداد',
            dataIndex: 'count',
            key: 'count',
            responsive: ['md'],
            render: (text, record) => (
                <div className="flex flex-col">
                    <RenderIf condition={record?.meta?.count?.male}>
                        <div className="flex gap-1">
                            <span>تعداد پسر:</span>
                            {record.meta?.count?.male}
                        </div>
                    </RenderIf>

                    <RenderIf condition={record?.meta?.count?.female}>
                        <div className="flex gap-1">
                            <span>تعداد دختر:</span>
                            {record.meta?.count?.female}
                        </div>
                    </RenderIf>
                </div>
            ),
        },

        {
            title: 'تاریخ ثبت',
            dataIndex: 'created_at',
            key: 'created_at',
            responsive: ['md'],
            render: (text) => {
                return convertToJalaliWithFormat(text, 'jYYYY/jMM/jDD HH:mm:ss');
            },
        },

        {
            title: 'آمار',
            key: 'stats',
            width: 180,
            responsive: ['md'],
            render: (_, record) => (
                <div className="flex gap-4">
                    <div className="text-center">
                        <Progress
                            type="circle"
                            percent={record.pending_percent}
                            size={46}
                            strokeColor="#faad14"
                            format={() => record.pending_percent + "%"}
                        />
                        <div className="text-xs mt-1">
                            در انتظار
                        </div>
                        <span>{record?.pending_count}</span>
                    </div>

                    <div className="text-center">
                        <Progress
                            type="circle"
                            percent={record.print_percent}
                            size={46}
                            strokeColor="#1677ff"
                            format={() => record.print_percent + "%"}
                        />
                        <div className="text-xs mt-1">
                            چاپ
                        </div>
                        <span>{record?.print_count}</span>
                    </div>

                    <div className="text-center">
                        <Progress
                            type="circle"
                            percent={record.deliver_percent}
                            size={46}
                            strokeColor="#52c41a"
                            format={() => record.deliver_percent + "%"}
                        />
                        <div className="text-xs mt-1">
                            تحویل
                        </div>
                        <span>{record?.deliver_count}</span>
                    </div>
                </div>
            ),
        },

        // Mobile
        {
            title: '',
            key: 'mobile',
            responsive: ['xs', 'sm'],
            render: (_, record) => (
                <div className="flex md:hidden flex-col gap-4 py-1">

                    {/* شناسه */}
                    <div className="flex items-center justify-between gap-3">
                    <span className="text-xs   dark: ">
                        #
                    </span>

                        <div className="flex items-center gap-2">
                        <span className="text-sm text-black dark:text-white">
                            {toFaNumberFormat(record.id)}
                        </span>

                            <Can permission={PermList.PRODUCT_DELIVERY_EDIT}>
                                <Link
                                    to={sprintf(URLS.admin.products.delivery.edit, {
                                        id: record.id,
                                    })}
                                >
                                    <Button
                                        size="small"
                                        type="dashed"
                                    >
                                        جزئیات
                                    </Button>
                                </Link>
                            </Can>
                        </div>
                    </div>

                    {/* توضیحات */}
                    <div className="flex flex-col gap-1">
                    <span className="text-xs   dark: ">
                        توضیحات
                    </span>

                        <span className="text-sm text-black dark:text-white">
                        {record.description || '-'}
                    </span>
                    </div>

                    <RenderIf condition={record?.category}>
                        <div className="flex justify-between gap-1">
                            <span className="text-xs   dark: ">
                                کد
                            </span>
                            <span className="text-sm text-black dark:text-white">
                                <Link to={sprintf(URLS.admin.products.delivery.category, {category: record.category})}>
                                    <Tag color={'blue'}> {record.category}</Tag>
                                </Link>
                            </span>
                        </div>
                    </RenderIf>

                    <RenderIf condition={record.meta?.deliver_to_lesson}>
                        <div className="flex justify-start gap-1">
                            <Tag color="purple">تحویل به مربی</Tag>
                        </div>

                    </RenderIf>


                    {/* تعداد */}
                    <div className="flex flex-col gap-1">
                    <span className="text-xs   dark: ">
                        تعداد
                    </span>

                        <div className="flex flex-col gap-1 text-sm text-black dark:text-white">
                            <RenderIf condition={record?.meta?.count?.male}>
                                <div className="flex gap-1">
                                    <span>تعداد پسر:</span>
                                    <span>{record.meta?.count?.male}</span>
                                </div>
                            </RenderIf>

                            <RenderIf condition={record?.meta?.count?.female}>
                                <div className="flex gap-1">
                                    <span>تعداد دختر:</span>
                                    <span>{record.meta?.count?.female}</span>
                                </div>
                            </RenderIf>

                            {!record?.meta?.count?.male &&
                                !record?.meta?.count?.female && (
                                    <span>-</span>
                                )}
                        </div>
                    </div>

                    {/* تاریخ ثبت */}
                    <div className="flex items-center justify-between gap-3">
                    <span className="text-xs   dark: ">
                        تاریخ ثبت
                    </span>

                        <span className="text-sm text-black dark:text-white">
                        {record.created_at
                            ? convertToJalaliWithFormat(
                                record.created_at,
                                'jYYYY/jMM/jDD HH:mm:ss'
                            )
                            : '-'}
                    </span>
                    </div>

                    {/* آمار */}
                    <div className="flex flex-col gap-2">
                    <span className="text-xs   dark: ">
                        آمار
                    </span>

                        <div className="flex justify-center gap-5 pt-1">
                            <div className="text-center">
                                <Progress
                                    type="circle"
                                    percent={record.pending_percent}
                                    size={46}
                                    strokeColor="#faad14"
                                    format={() => record.pending_percent + "%"}
                                />
                                <div className="text-xs mt-1">
                                    در انتظار
                                </div>
                                <span className="text-sm">
                                {record?.pending_count ?? 0}
                            </span>
                            </div>

                            <div className="text-center">
                                <Progress
                                    type="circle"
                                    percent={record.print_percent}
                                    size={46}
                                    strokeColor="#1677ff"
                                    format={() => record.print_percent + "%"}
                                />
                                <div className="text-xs mt-1">
                                    چاپ
                                </div>
                                <span className="text-sm">
                                {record?.print_count ?? 0}
                            </span>
                            </div>

                            <div className="text-center">
                                <Progress
                                    type="circle"
                                    percent={record.deliver_percent}
                                    size={46}
                                    strokeColor="#52c41a"
                                    format={() => record.deliver_percent + "%"}
                                />
                                <div className="text-xs mt-1">
                                    تحویل
                                </div>
                                <span className="text-sm">
                                {record?.deliver_count ?? 0}
                            </span>
                            </div>
                        </div>
                    </div>

                </div>
            ),
        },
    ];

    return (
        <AdminLayout backTo={URLS.admin.products.dashboard} pageTitle={'لیست گروه‌های تحویل'}>

            <TableSearch
                searchInput={false}
                addButton={
                    <div className={'flex justify-end gap-1'}>

                        <Can permission={PermList.PRODUCT_DELIVERY_STEP_ADD}>
                            <Button
                                color={'primary'}
                                variant={'solid'}
                                size={'small'}
                                onClick={() => navigate(URLS.admin.products.delivery.create)}>
                                <div className={'hidden md:flex'}>
                                        ایجاد گروه تحویل جدید
                                </div>
                                <div className={'flex md:hidden'}>
                                    +
                                </div>

                            </Button>

                            <Button

                                size={'small'}
                                onClick={() => navigate(URLS.admin.products.delivery.categoryFull)}>
                                <div className={'hidden md:flex'}>
                                    آمار تجمیعی
                                </div>
                                <div className={'flex md:hidden'}>
                                    +
                                </div>

                            </Button>
                        </Can>


                    </div>
                }
                apiFn={useApiSearchAdminProductsDeliveryStep}
                columns={columns}
                scroll={{x: true}}
                responsive={true}
            />

        </AdminLayout>
    );
}

export default AdminProductDeliveryStepList;